import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/packages/ui-web/src/backgrounds/sparkles.tsx");
